<template>
  <div class="box vh-140">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> 项目账单</h3>
    </div>
    <div class="box-body">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color: #dec647">
            <div class="visual"><i class="fa fa-viacoin text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">测评人数</div>
                <span class="count">{{ countMap.total || 0 }}人</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color: #32c5d2;">
            <div class="visual"><i class="fa fa-diamond text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">完成人数</div>
                <span class="count">{{ countMap.finish || 0 }}人</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color:#3598dc">
            <div class="visual"><i class="fa fa-credit-card text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">付款人数</div>
                <span class="count">{{ countMap.pay || 0 }}人</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="dashboard-stat" style="background-color: #e7505a">
            <div class="visual"><i class="fa fa-send text-white"></i></div>
            <div class="details">
              <div class="number">
                <div class="desc">付款总额</div>
                <span class="count">{{ countMap.price || 0 }}元</span>
              </div>
            </div>
          </div>
        </el-col>

      </el-row>

      <!-- 工具栏-->
      <el-row>
        <el-col>
          <el-form size="small" ref="searchFm" :model="searchFm" inline>
            <el-form-item label="企业名称：" prop="companyId" :rules="[{ required: true, message: '请选择企业', trigger: 'blur' }]">
              <el-select clearable filterable remote v-model="searchFm.companyId" @change="selectCompany" :remote-method="fetchCompany" placeholder="请选择企业">
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称：" prop="projectId">
              <el-select clearable filterable remote v-model="searchFm.projectId" :remote-method="fetchSearchProject" placeholder="项目名称">
                <el-option
                  v-for="item in searchProjectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间范围：" prop="statue">
              <el-date-picker
                clearable
                v-model="searchFm.time"
                type="daterange"
                @change="selectTime"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-button size="small" type="primary" @click="doSearch" plain><i class="fa fa-search"></i> 搜索</el-button>
          </el-form>
        </el-col>
      </el-row>

      <el-table :header-cell-style="{ background: '#eef1f6', color: '#606266' }" :data="projectList " border :stripe="true" style="width: 100%">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" align="center" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + page.pageSize * (page.pageNo - 1) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" min-width="300">
          <template slot-scope="scope">
            <el-button size="medium" type="text" @click="toDetail(scope.row.id)">{{ scope.row.name }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="目标企业" min-width="250" prop="unit"></el-table-column>
        <el-table-column label="方案类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.schemeType=='standard'" type="" effect="plain" size="small">标准方案</el-tag>
            <el-tag v-if="scope.row.schemeType=='person'" type="success" effect="plain" size="small">个人方案</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="方案名称" width="180" prop="schemeName"></el-table-column>
        <el-table-column label="报告价格" width="180">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.free==0" type="success" effect="plain" size="small">{{ scope.row.price }}元</el-tag>
            <el-tag v-else type="warning" effect="plain" size="small">免费</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="已测人数" width="80" prop="num"></el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==0" type="warning" effect="plain" size="small">未开始</el-tag>
            <el-tag v-if="scope.row.status==1" type="" effect="plain" size="small">进行中</el-tag>
            <el-tag v-if="scope.row.status==2" type="success" effect="plain" size="small">已结束</el-tag>
          </template>
        </el-table-column>
      </el-table>


      <!-- 分页 -->
      <page-bar v-model="page" @change="fetchData"></page-bar>
    </div>

  </div>
</template>

<script>
import PageBar from "@components/PageBar";
import { fetchList as fetchCompany } from "@/api/manage/company";
import { fetchData as fetchProject } from "@api/evaluation/project";
import { countOrder } from "@/api/evaluation/report";
import { mapGetters } from "vuex";
import { parseTime } from "@/utils/index";
import dayjs from "dayjs";

export default {
  name: "",
  data() {
    return {
      searchFm: {},
      countMap: {},
      companyList: [],
      searchProjectList: [],
      projectList: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        param: {}
      }
    };
  },
  watch: {
    "searchFm.userId": {
      handler(userId, oldType) {
        this.projectList = [];
        this.$set(this.searchFm, "projectId", null);
        this.fetchSearchProject();
      }
    }
  },
  computed: {
    ...mapGetters(["user", "company"])
  },
  created() {
    this.fetchCompany();
  },
  components: {
    PageBar
  },
  methods: {
    selectTime(time) {
      if (time) {
        this.searchFm.startTime = dayjs((time[0] + " 00:00:00")).unix();
        this.searchFm.endTime = dayjs(time[1] + " 23:59:59").unix();
      }
    },
    formatDate(cell) {
      if (cell.startTime) {
        return parseTime(time, "{y}-{m}-{d}");
      }
    },
    selectCompany(companyId) {
      this.projectList = [];
      this.$set(this.searchFm, "projectId", null);
      let company = this.companyList.filter(x => x.id == companyId)[0];
      this.searchFm.userId = company.userId;
      this.fetchSearchProject(company.userId);
    },
    countOrder() {
      countOrder(this.searchFm).then(resp => {
        this.countMap = resp.data.result || {};
      });
    },
    fetchCompany(name) {
      let param = name ? { name: `%${name}` } : {};
      fetchCompany({ param }).then(resp => {
        this.companyList = resp.data.result.records || [];
      });
    },
    fetchProject() {
      if (!this.searchFm.userId) {
        this.$message.error("请先选择企业！");
        return;
      }

      let { pageNo, pageSize } = this.page;
      let id = this.searchFm.projectId ? this.searchFm.projectId : null;
      let query = { pageNo, pageSize, param: { id: this.searchFm.projectId ? this.searchFm.projectId : null, free: 0, name: name ? `%${name}` : null } };
      fetchProject(this.searchFm.userId, query).then(resp => {
        this.page = resp.data.result;
        this.projectList = resp.data.result.records || [];
      });
    },
    fetchSearchProject(name) {
      if (!this.searchFm.userId) {
        this.$message.error("请先选择企业！");
        return;
      }

      let { pageNo, pageSize } = this.page;
      let id = this.searchFm.projectId ? this.searchFm.projectId : null;
      let query = { pageNo, pageSize, param: { id: id, free: 0, name: name ? `%${name}` : null } };
      fetchProject(this.searchFm.userId, query).then(resp => {
        this.page = resp.data.result;
        this.searchProjectList = resp.data.result.records || [];
      });
    },
    doSearch() {
      this.$refs["searchFm"].validate((valid) => {
        if (valid) {
          this.countOrder();
          this.fetchProject();
        }
      });
    },
    toDetail(id) {
      this.$router.push({ name: "order-report-list", query: { id: id, startTime: this.searchFm.startTime, endTime: this.searchFm.endTime } });
    }
  }
};
</script>

<style type="text/scss" lang="scss">
.dashboard-stat {
  border: none;
}

.dashboard-stat .visual {
  font-size: 58px;
  float: left;
  min-height: 50px;
}

.dashboard-stat .details {
  float: right;
  color: #ffffff;
}
</style>
